import { useCheckFinanceExportReportsStatus } from '../../api/hooks/useCheckFinanceExportReportsStatus';
import { useDeleteFinanceExportReport } from '../../api/hooks/useDeleteFinanceExportReport';
import { useGetFinanceExportReports } from '../../api/hooks/useGetFinanceExportReports';
import { useRetryFinanceExportReport } from '../../api/hooks/useRetryFinanceExportReport';

export const useFinanceExportTable = () => {
    const { data: reports, isLoading } = useGetFinanceExportReports();
    const { mutateAsync: deleteReport, isPending: isDeleting } = useDeleteFinanceExportReport();
    const { mutateAsync: retryReport, isPending: isRetrying } = useRetryFinanceExportReport();

    useCheckFinanceExportReportsStatus();

    const handleDelete = async (id: number) => {
        await deleteReport(id);
    };

    const handleRetry = async (id: number) => {
        await retryReport(id);
    };

    const handleDownload = (fileUrl: string) => {
        window.open(fileUrl, '_blank');
    };

    return {
        reports,
        isLoading,
        isDeleting,
        isRetrying,
        handleDelete,
        handleRetry,
        handleDownload,
    };
};
